module.exports = __webpack_public_path__ + "img/2eabaff05cad8017084ef08aa815104d.png";